<p-table #dt [value]="searchResults" [columns]="cols" [rows]="30" [paginator]="true" [scrollable]="true" scrollHeight="400px"
    [rowsPerPageOptions]="[30,60,90]" [showCurrentPageReport]="true" (sortFunction)="customSort($event)" [customSort]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [(selection)]="selectedResults" [tableStyle]="{'min-width': '100rem'}"
    selectionMode="multiple" [rowHover]="true" (onPage)="onPageChanged($event)">
    <!-- <ng-template pTemplate="emptymessage">
        <p class="flex align-items-center justify-content-center p-3 text-lg font-medium no-results-message no-results-message">No Results Available</p>
    </ng-template> -->
    <ng-template pTemplate="caption">
        <ng-content></ng-content>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th style="width:0%;">
                <p-tableHeaderCheckbox/>
            </th>
            <th style="width: 20%;">
                <div class="flex text-left gap-3">
                    <div class="mt-2">
                        {{'components.keywordResults.keywordHeader' | translate}}
                    </div>
                    <div>
                        <p-columnFilter
                            id="filter-keywordData-keyword"
                            pTooltip="{{'components.keywordResults.filter' | translate}}"
                            *ngIf="selectedSearchType === 'relatedKeywords'"
                            type="text"
                            field="keywordData.keyword"
                            display="menu"
                            matchMode="contains"></p-columnFilter>
                        <p-columnFilter
                            id="filter-keyword"
                            pTooltip="{{'components.keywordResults.filter' | translate}}"
                            *ngIf="selectedSearchType === 'keywordIdeas' || selectedSearchType === 'keywordSuggestions'"
                            type="text"
                            field="keyword"
                            display="menu"
                            matchMode="contains"></p-columnFilter>
                    </div>
                </div>
            </th>
            @if (resultCases === 'amazon' ) {
                <th class="text-center" pSortableColumn="volume" pTooltip="{{'components.keywordResults.volumeHeaderTooltip' | translate}}">{{'components.keywordResults.volumeHeader' | translate}}</th>

            }@else if (resultCases === 'bing') {
                <th [ngClass]="isHovered ? 'bing-max-w' : 'bing-default'">
                    Trend
                </th>
                <th class="text-center" pSortableColumn="kd" pTooltip="{{'components.keywordResults.kdHeaderTooltip' | translate}}">{{'components.keywordResults.kdHeader' | translate}}</th>
                <th class="text-center" pSortableColumn="volume" pTooltip="{{'components.keywordResults.volumeHeaderTooltip' | translate}}">{{'components.keywordResults.volumeHeader' | translate}}</th>
                <th class="text-center"  class="search-intent" pSortableColumn="intent" pTooltip="{{'components.keywordResults.intentHeaderTooltip' | translate}}">{{'components.keywordResults.intentHeader' | translate}}</th>
                <th class="text-center" pSortableColumn="cpc" pTooltip="{{'components.keywordResults.cpcHeaderTooltip' | translate}}">{{'components.keywordResults.cpcHeader' | translate}}</th>
                <th class="text-center" pSortableColumn="competition" pTooltip="{{'components.keywordResults.competitionTooltip' | translate}}">{{'components.keywordResults.competitionHeader' | translate}}</th>

            } @else {
                <th [ngClass]="isHovered ? 'max-ww-6rem' : 'default-th'">
                    Trend
                </th>
                <th class="text-center w-1" pSortableColumn="kd" pTooltip="{{'components.keywordResults.kdHeaderTooltip' | translate}}">{{'components.keywordResults.kdHeader' | translate}}</th>
                <th class="text-center w-1" pSortableColumn="volume" pTooltip="{{'components.keywordResults.volumeHeaderTooltip' | translate}}">{{'components.keywordResults.volumeHeader' | translate}}</th>
                <th class="text-center w-1" pSortableColumn="intent" pTooltip="{{'components.keywordResults.intentHeaderTooltip' | translate}}">{{'components.keywordResults.intentHeader' | translate}}</th>
                <th class="text-center w-1" pSortableColumn="cpc" pTooltip="{{'components.keywordResults.cpcHeaderTooltip' | translate}}">{{'components.keywordResults.cpcHeader' | translate}}</th>
                <th class="text-center w-1" pSortableColumn="competition" pTooltip="{{'components.keywordResults.competitionTooltip' | translate}}">{{'components.keywordResults.competitionHeader' | translate}}</th>
                @if (!isKeywordSearch) {
                    <th class="text-center w-1" pSortableColumn="rankedSerpElement.serpItem.rankGroup">Rank Group</th>
                }
            }
            <!-- <th class="text-center" style="width:2%;" *ngIf="showAnalysisModal">
                AI
            </th> -->
        </tr>
        <!-- <tr>
            <th></th>
            <th *ngIf="selectedSearchType === 'relatedKeywords'">
                <p-columnFilter type="text" field="keywordData.keyword" matchMode="contains"></p-columnFilter>
            </th>
            <th *ngIf="selectedSearchType === 'keywordIdeas' || selectedSearchType === 'keywordSuggestions'">
                <p-columnFilter type="text" field="keyword" matchMode="contains"></p-columnFilter>
            </th>
            <th colspan="14"></th>
        </tr> -->
    </ng-template>
    <ng-template pTemplate="body" let-result let-rowIndex="rowIndex">
        <tr>
            <td>
                <p-tableCheckbox [value]="result"></p-tableCheckbox>
            </td>
            <!-- <td class="text-center">
                <button class="p-button-text w-full text-left" pButton
                (click)="onSelectedKeywordClicked(result)">{{result?.keyword ?? result?.keywordData?.keyword}}&nbsp;<i class="pi pi-eye"></i></button>
            </td> -->
            @if (resultCases === 'amazon' ) {
                <td class="text-left">
                    {{result?.keyword ?? result?.keywordData?.keyword}}
                </td>
                <td class="text-center">
                    {{(result?.keywordInfo?.searchVolume | number:'1.0-0':'en-US') ?? (result?.keywordData?.keywordInfo?.searchVolume | number:'1.0-0':'en-US')}}
                </td>
            }@else if (resultCases === 'bing') {
                <td class="text-left">
                    <button
                        class="p-button-text w-full text-left"
                        pButton
                        id="keyword-action-btn-{{rowIndex}}"
                        (click)="onSelectedKeywordClicked(result)">
                        {{result?.keyword ?? result?.keywordData?.keyword}}&nbsp;<i class="pi pi-eye"></i>
                    </button>
                </td>
                <div class="text-center" (mouseover)="onMouseOver()" (mouseout)="onMouseOut()" (touchstart)="onTouchStart()" (touchend)="onTouchEnd()">
                    <gig-competitor-trend-chart [sourceData]="result?.keywordInfo?.monthlySearches ?? result?.keywordData?.keywordInfo?.monthlySearches "></gig-competitor-trend-chart>
                </div>
                <td class="text-center">
                    {{result?.keywordProperties?.keywordDifficulty ?? result?.keywordData?.keywordProperties?.keywordDifficulty}}
                </td>
                <td class="text-center">
                    {{(result?.keywordInfo?.searchVolume | number:'1.0-0':'en-US') ?? (result?.keywordData?.keywordInfo?.searchVolume | number:'1.0-0':'en-US')}}
                </td>
                <td class="flex justify-content-center">
                    <p [class]="getIntentClasses(result)" class="font-bold badge" [pTooltip]="result?.searchIntentInfo?.mainIntent ?? result?.keywordData?.searchIntentInfo?.mainIntent">
                        {{(result?.searchIntentInfo?.mainIntent | extractCapitalizeFirstLetter) ?? (result?.keywordData?.searchIntentInfo?.mainIntent  | extractCapitalizeFirstLetter)}}
                    </p>
                </td>
                <td class="text-center">
                    {{(result?.keywordInfo?.cpc | currency:'USD') ?? (result?.keywordData?.keywordInfo?.cpc | currency:'USD')}}
                </td>
                <td class="text-center">
                    {{result?.keywordInfo?.competition ?? result?.keywordData?.keywordInfo?.competition | percent}}
                </td>
            }@else {
                <td class="text-left">
                    <button
                        class="p-button-text w-full text-left"
                        pButton
                        id="keyword-action-btn-{{rowIndex}}"
                        (click)="onSelectedKeywordClicked(result)">
                        {{result?.keyword ?? result?.keywordData?.keyword}}&nbsp;<i class="pi pi-eye"></i>
                    </button>
                </td>
                <td class="text-center" (mouseover)="onMouseOver()" (mouseout)="onMouseOut()" (touchstart)="onTouchStart()" (touchend)="onTouchEnd()">
                    <gig-competitor-trend-chart [sourceData]="result?.keywordInfo?.monthlySearches ?? result?.keywordData?.keywordInfo?.monthlySearches"></gig-competitor-trend-chart>
                </td>
                <td class="text-center">
                    {{result?.keywordProperties?.keywordDifficulty ?? result?.keywordData?.keywordProperties?.keywordDifficulty}}
                </td>
                <td class="text-center">
                    {{(result?.keywordInfo?.searchVolume | number:'1.0-0':'en-US') ?? (result?.keywordData?.keywordInfo?.searchVolume | number:'1.0-0':'en-US')}}
                </td>
                <td class="flex justify-content-center">
                    <span [class]="getIntentClasses(result)" class="font-bold badge" [pTooltip]="result?.searchIntentInfo?.mainIntent ?? result?.keywordData?.searchIntentInfo?.mainIntent">
                        {{(result?.searchIntentInfo?.mainIntent | extractCapitalizeFirstLetter) ?? (result?.keywordData?.searchIntentInfo?.mainIntent  | extractCapitalizeFirstLetter)}}
                    </span>
                </td>

                <td class="text-center">
                    {{(result?.keywordInfo?.cpc | currency:'USD') ?? (result?.keywordData?.keywordInfo?.cpc | currency:'USD')}}
                </td>

                <td class="text-center">
                    {{result?.keywordInfo?.competition ?? result?.keywordData?.keywordInfo?.competition | percent}}
                </td>
                @if (!isKeywordSearch) {
                    <td class="text-center">
                        {{result?.rankedSerpElement?.serpItem?.rankGroup}}
                    </td>
                }
            }
            <!-- <td class="text-center" *ngIf="showAnalysisModal">
                <gig-askKevin-analysis-modal
                    id="ai-analysis-modal-{{rowIndex}}"
                    [keyword]="result"></gig-askKevin-analysis-modal>
            </td> -->
        </tr>
    </ng-template>
</p-table>
